import NavComponent from "../lib/nav_component";

export const PaneOptionsTitleComponentConfig = {
    baseHtmlClass: 'nav_title',
    selector: '.nav_title',

    datasetConfigKey: 'nav_title__online_app_nav_data',
    identifierDatasetConfigKey: 'identifier',

    linkSelector: '.nav_title__link',
};

export class PaneOptionsTitleComponent extends NavComponent {

    constructor(id_or_element, paneOptionsComponent) {
        super(id_or_element, PaneOptionsTitleComponentConfig);

        this.setDatasetConfig(PaneOptionsTitleComponentConfig.datasetConfigKey);
        this.identifier = this.getIdentifier();
        this.isCollapser = paneOptionsComponent.collapsable;

        this.paneOptionsComponent = paneOptionsComponent;
        this.linkElement = this.element.querySelector(PaneOptionsTitleComponentConfig.linkSelector)

        if (this.isCollapser) this.linkElement.addEventListener('click', this.handleLinkClick.bind(this));

        this.renderInitial()
    }

    handleLinkClick(e) {
        this.paneOptionsComponent.toggleCollapse();
        e.preventDefault();
    }

    getIdentifier() {
        const identifier = this.getDatasetConfigValue(PaneOptionsTitleComponentConfig.identifierDatasetConfigKey);
        if(!identifier) return;
        return identifier;
    }


    isOpen() {
        return !!this.paneOptionsComponent.isOpen();
    }

    renderInitial() {
        this.conditionallySetHtmlClassState(this.isCollapser, 'collapser');
    }

    render() {
        this.conditionallySetHtmlClassState(this.isOpen(), 'open');
        this.conditionallySetHtmlClassState(!this.isOpen(), 'closed');
    }


}
